import React__default, { useCallback, useEffect } from 'react';
import { handleSetColorMode, initColorMode } from './utils.esm.js';
import { useMediaQuery } from '../hooks/use-media-query.esm.js';

var useColorModeState = function useColorModeState(defaultMode) {
  var _useMediaQuery = useMediaQuery("(prefers-color-scheme: dark)"),
      darkmode = _useMediaQuery[0];

  var _useMediaQuery2 = useMediaQuery("(prefers-color-scheme: light)"),
      lightmode = _useMediaQuery2[0];

  var systemMode = darkmode ? "dark" : lightmode ? "light" : "light";

  var _React$useState = React__default.useState(defaultMode || systemMode),
      colorMode = _React$useState[0],
      setMode = _React$useState[1];

  var setColorMode = useCallback(function (mode) {
    setMode(mode);
    handleSetColorMode(mode);
  }, [colorMode, setMode]);
  var toggleColorMode = useCallback(function () {
    if (colorMode === "light") {
      setColorMode("dark");
      return;
    }

    if (colorMode === "dark") {
      setColorMode("light");
      return;
    }

    if (systemMode) {
      setColorMode("dark");
      return;
    }
  }, [colorMode, setColorMode, systemMode]);
  return {
    colorMode: colorMode,
    toggleColorMode: toggleColorMode,
    setColorMode: setColorMode,
    systemMode: systemMode
  };
};
var useColorModeEffect = function useColorModeEffect(defaultMode) {
  var _useColorModeState = useColorModeState(defaultMode),
      colorMode = _useColorModeState.colorMode,
      setColorMode = _useColorModeState.setColorMode,
      systemMode = _useColorModeState.systemMode;

  useEffect(function () {
    if (!colorMode && systemMode) {
      setColorMode(systemMode);
    }
  }, [colorMode, systemMode]);
  var isBrowser = typeof window !== "undefined";
  useEffect(function () {
    initColorMode(setColorMode, colorMode || systemMode);
  }, [isBrowser]);
};

export { useColorModeEffect, useColorModeState };
//# sourceMappingURL=hooks.esm.js.map
